export default __webpack_public_path__ + "static/media/brittany-welsh--240.0659c18a.jpg";